import { VIPFormAdd } from './components/VIPFormAdd';
import { VIPFormEdit } from './components/VIPFormEdit';
import React, { forwardRef } from 'react';
import { VIPData } from './components/VIPForm';

type VIPEditorProps = (
  | {
      state: 'edit';
      editId: string;
    }
  | {
      state: 'add';
    }
) & {
  eventId: string;
  onSubmit: (data: VIPData) => void;
};

export const VIPEditor = forwardRef((props: VIPEditorProps, ref) => {
  const { state, onSubmit, eventId } = props;

  if (state === 'add') {
    return (
      <VIPFormAdd
        ref={ref}
        eventId={eventId}
        onSubmit={onSubmit}
      />
    );
  } else {
    return (
      <VIPFormEdit
        ref={ref}
        editId={props.editId}
        onSubmit={onSubmit}
      />
    );
  }
});
